/**
 * setAsideNavActiveLink.js — サイドナビのスクロール追従
 *
 * スクロール位置に応じてサイドナビのリンクに aria-current="page" を設定。
 * js-elevatorSection クラスを持つセクションを検知対象とする。
 */
export function setAsideNavActiveLink() {
  const sections = document.querySelectorAll(".js-elevatorSection");
  const navLinks = document.querySelectorAll(".s-sidenav__link");

  if (sections.length === 0 || navLinks.length === 0) return;

  function update() {
    const windowHeight = window.innerHeight;
    const threshold = windowHeight / 2 - windowHeight / 4;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    let activeId = null;

    sections.forEach(function (section) {
      const rect = section.getBoundingClientRect();
      if (rect.top <= threshold) {
        activeId = section.id;
      }
    });

    // ページ最上部（どのセクションも検出されない場合）は #top をハイライト
    if (activeId === null && scrollTop < windowHeight / 2) {
      activeId = "top";
    }

    navLinks.forEach(function (link) {
      const href = link.getAttribute("href");
      if (href === "#" + activeId || href.endsWith("#" + activeId)) {
        link.setAttribute("aria-current", "page");
      } else {
        link.removeAttribute("aria-current");
      }
    });
  }

  window.addEventListener("scroll", update, { passive: true });
  update();
}
